module.exports = __webpack_public_path__ + "static/img/day_report_fail.bc704c28.png";